import { c as _c } from "react/compiler-runtime";
import { Button } from "@navikt/ds-react";
import { useFormContext } from "@/shared/components/form/hooks/form-context";
export const SubmitButton = t0 => {
  const $ = _c(6);
  const {
    label,
    uiSelector
  } = t0;
  const form = useFormContext();
  let t1;
  if ($[0] !== label || $[1] !== uiSelector) {
    t1 = isSubmitting => <Button type="submit" variant="primary" disabled={isSubmitting} data-testid={uiSelector ? uiSelector : "submit-button"}>{label}</Button>;
    $[0] = label;
    $[1] = uiSelector;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== form.Subscribe || $[4] !== t1) {
    t2 = <form.Subscribe selector={_temp}>{t1}</form.Subscribe>;
    $[3] = form.Subscribe;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
function _temp(state) {
  return state.isSubmitting;
}